<template>
  <div class="contact">
    <div class="contact__button" @click="toggleContact">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    </div>
    <div
      v-if="showContactList"
      class="contact__list"
      v-click-outside="closePopup"
    >
      <a href="mailto:support@momentumsuite.com" class="contact__list__item">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M12 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V11.5C22.75 11.91 22.41 12.25 22 12.25C21.59 12.25 21.25 11.91 21.25 11.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H12C12.41 19.75 12.75 20.09 12.75 20.5C12.75 20.91 12.41 21.25 12 21.25Z"
          />
          <path
            d="M11.9998 12.87C11.1598 12.87 10.3098 12.61 9.65978 12.08L6.52978 9.57996C6.20978 9.31996 6.14978 8.84997 6.40978 8.52997C6.66978 8.20997 7.13977 8.15997 7.45977 8.40997L10.5898 10.91C11.3498 11.52 12.6398 11.52 13.3998 10.91L16.5298 8.40997C16.8498 8.14997 17.3198 8.19997 17.5798 8.52997C17.8398 8.84997 17.7898 9.32996 17.4598 9.57996L14.3298 12.08C13.6898 12.61 12.8398 12.87 11.9998 12.87Z"
          />
          <path
            d="M15.8201 21.78C15.4401 21.78 15.0801 21.64 14.8201 21.38C14.5101 21.07 14.3701 20.62 14.4401 20.15L14.6301 18.8C14.6801 18.45 14.8901 18.03 15.1401 17.78L18.68 14.24C19.16 13.76 19.6301 13.51 20.1401 13.46C20.7601 13.4 21.38 13.66 21.96 14.24C22.54 14.82 22.8 15.43 22.74 16.06C22.69 16.56 22.43 17.04 21.96 17.52L18.4201 21.06C18.1701 21.31 17.75 21.52 17.4 21.57L16.05 21.76C15.97 21.77 15.9001 21.78 15.8201 21.78ZM20.31 14.95C20.3 14.95 20.29 14.95 20.28 14.95C20.14 14.96 19.95 15.09 19.74 15.3L16.2001 18.84C16.1701 18.87 16.12 18.97 16.12 19.01L15.9401 20.26L17.1901 20.08C17.2301 20.07 17.33 20.02 17.36 19.99L20.9 16.45C21.11 16.23 21.24 16.05 21.2501 15.91C21.2701 15.71 21.07 15.47 20.9 15.3C20.74 15.14 20.51 14.95 20.31 14.95Z"
          />
          <path
            d="M20.9201 18.2499C20.8501 18.2499 20.7801 18.2399 20.7201 18.2199C19.4001 17.8499 18.3501 16.7999 17.9801 15.4799C17.8701 15.0799 18.1001 14.6699 18.5001 14.5499C18.9001 14.4399 19.3101 14.6699 19.4201 15.0699C19.6501 15.8899 20.3001 16.5399 21.1201 16.7699C21.5201 16.8799 21.7501 17.2999 21.6401 17.6999C21.5501 18.0299 21.2501 18.2499 20.9201 18.2499Z"
          />
        </svg>
        <span>{{ $t("navigation.help.contact") }}</span>
      </a>
      <div class="contact__list__item" @click="showContactSales = true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M12.88 20.8599H6.81C3.26 20.8599 2 18.3699 2 16.0499V7.94989C2 4.48989 3.35 3.13989 6.81 3.13989H12.88C16.34 3.13989 17.69 4.48989 17.69 7.94989V16.0499C17.69 19.5099 16.34 20.8599 12.88 20.8599ZM6.81 4.65989C4.2 4.65989 3.52 5.33989 3.52 7.94989V16.0499C3.52 17.2799 3.95 19.3399 6.81 19.3399H12.88C15.49 19.3399 16.17 18.6599 16.17 16.0499V7.94989C16.17 5.33989 15.49 4.65989 12.88 4.65989H6.81Z"
          />
          <path
            d="M20.7799 18.11C20.3499 18.11 19.7999 17.97 19.1699 17.53L16.4999 15.66C16.2999 15.52 16.1799 15.29 16.1799 15.04V8.95999C16.1799 8.70999 16.2999 8.48 16.4999 8.33999L19.1699 6.46999C20.3599 5.63999 21.2299 5.87999 21.6399 6.08999C22.0499 6.30999 22.7499 6.87999 22.7499 8.32999V15.66C22.7499 17.11 22.0499 17.69 21.6399 17.9C21.4499 18.01 21.1499 18.11 20.7799 18.11ZM17.6899 14.64L20.0399 16.28C20.4899 16.59 20.8099 16.62 20.9399 16.55C21.0799 16.48 21.2299 16.2 21.2299 15.66V8.33999C21.2299 7.78999 21.0699 7.51999 20.9399 7.44999C20.8099 7.37999 20.4899 7.40999 20.0399 7.71999L17.6899 9.35999V14.64Z"
          />
          <path
            d="M11.5 11.75C10.26 11.75 9.25 10.74 9.25 9.5C9.25 8.26 10.26 7.25 11.5 7.25C12.74 7.25 13.75 8.26 13.75 9.5C13.75 10.74 12.74 11.75 11.5 11.75ZM11.5 8.75C11.09 8.75 10.75 9.09 10.75 9.5C10.75 9.91 11.09 10.25 11.5 10.25C11.91 10.25 12.25 9.91 12.25 9.5C12.25 9.09 11.91 8.75 11.5 8.75Z"
          />
        </svg>
        <span>{{ $t("navigation.help.meeting") }}</span>
      </div>
    </div>
    <book-meeting :show="showContactSales" @close="closeContactSales" />
  </div>
</template>

<script>
const BookMeeting = () => import("@/components/BookMeeting");
export default {
  name: "ContactUs",
  components: { BookMeeting },
  data() {
    return {
      showContactList: false,
      showContactSales: false,
    };
  },
  methods: {
    toggleContact() {
      this.showContactList = !this.showContactList;
    },
    closeContactSales() {
      this.showContactSales = false;
    },
    closePopup() {
      this.showContactList = false;
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
